const lsdata = [
    [
        '2024_11_01_P_Decena.tif',
        '2024_10_21_P_Decena.tif',
        '2024_10_11_P_Decena.tif',
        '2024_10_01_P_Decena.tif',
        '2024_09_21_P_Decena.tif',
        '2024_09_11_P_Decena.tif',
        '2024_09_01_P_Decena.tif',
        '2024_08_21_P_Decena.tif',
        '2024_08_11_P_Decena.tif',
        '2024_08_01_P_Decena.tif',
        '2024_07_21_P_Decena.tif',
    ],
    [
        '2024_11_01_ETP_Decena.tif',
        '2024_10_21_ETP_Decena.tif',
        '2024_10_11_ETP_Decena.tif',
        '2024_10_01_ETP_Decena.tif',
        '2024_09_21_ETP_Decena.tif',
        '2024_09_11_ETP_Decena.tif',
        '2024_09_01_ETP_Decena.tif',
        '2024_08_21_ETP_Decena.tif',
        '2024_08_11_ETP_Decena.tif',
        '2024_08_01_ETP_Decena.tif',
        '2024_07_21_ETP_Decena.tif',
    ],
    [
        '2024_11_01_A_Decena.tif',
        '2024_10_21_A_Decena.tif',
        '2024_10_11_A_Decena.tif',
        '2024_10_01_A_Decena.tif',
        '2024_09_21_A_Decena.tif',
        '2024_09_11_A_Decena.tif',
        '2024_09_01_A_Decena.tif',
        '2024_08_21_A_Decena.tif',
        '2024_08_11_A_Decena.tif',
        '2024_08_01_A_Decena.tif',
        '2024_07_21_A_Decena.tif',
    ],
    [
        '2024_11_01_AD_Decena.tif',
        '2024_10_21_AD_Decena.tif',
        '2024_10_11_AD_Decena.tif',
        '2024_10_01_AD_Decena.tif',
        '2024_09_21_AD_Decena.tif',
        '2024_09_11_AD_Decena.tif',
        '2024_09_01_AD_Decena.tif',
        '2024_08_21_AD_Decena.tif',
        '2024_08_11_AD_Decena.tif',
        '2024_08_01_AD_Decena.tif',
        '2024_07_21_AD_Decena.tif',
    ],

    [
        '2024_11_01_ETR_Decena.tif',
        '2024_10_21_ETR_Decena.tif',
        '2024_10_11_ETR_Decena.tif',
        '2024_10_01_ETR_Decena.tif',
        '2024_09_21_ETR_Decena.tif',
        '2024_09_11_ETR_Decena.tif',
        '2024_09_01_ETR_Decena.tif',
        '2024_08_21_ETR_Decena.tif',
        '2024_08_11_ETR_Decena.tif',
        '2024_08_01_ETR_Decena.tif',
        '2024_07_21_ETR_Decena.tif',
    ],
    [],
    [],
    [],
    [],
    [],
    [
        'R3_2024_10_25.tif',
        'R3_2024_10_24.tif',
        'R3_2024_10_23.tif',
        'R3_2024_10_22.tif',
        'R3_2024_10_21.tif',
        'R3_2024_10_20.tif',
        'R3_2024_10_19.tif',
        'R3_2024_10_18.tif',
        'R3_2024_10_17.tif',
        'R3_2024_10_16.tif',
        'R3_2024_10_15.tif',
        'R3_2024_10_14.tif',
        'R3_2024_10_13.tif',
        'R3_2024_10_12.tif',
        'R3_2024_10_11.tif',
        'R3_2024_10_10.tif',
        'R3_2024_10_09.tif',
        'R3_2024_10_08.tif',
        'R3_2024_10_07.tif',
        'R3_2024_10_06.tif',
        'R3_2024_10_05.tif',
        'R3_2024_10_04.tif',
        'R3_2024_10_03.tif',
        'R3_2024_10_02.tif',
        'R3_2024_10_01.tif',
    ],
    [
        '2024_09_IPE_01meses.tif',
        '2024_08_IPE_01meses.tif',
        '2024_07_IPE_01meses.tif',
        '2024_06_IPE_01meses.tif',
        '2024_05_IPE_01meses.tif',
        '2024_04_IPE_01meses.tif',
        '2024_03_IPE_01meses.tif',
        '2024_02_IPE_01meses.tif',
        '2024_01_IPE_01meses.tif',
        '2023_12_IPE_01meses.tif',
        '2023_11_IPE_01meses.tif',
        '2023_10_IPE_01meses.tif',
        '2023_09_IPE_01meses.tif',
        '2023_08_IPE_01meses.tif',
        '2023_07_IPE_01meses.tif',
        '2023_06_IPE_01meses.tif',
        '2023_05_IPE_01meses.tif',
        '2023_04_IPE_01meses.tif',
    ],
    [
        '2024_09_IPE_03meses.tif',
        '2024_08_IPE_03meses.tif',
        '2024_07_IPE_03meses.tif',
        '2024_06_IPE_03meses.tif',
        '2024_05_IPE_03meses.tif',
        '2024_04_IPE_03meses.tif',
        '2024_03_IPE_03meses.tif',
        '2024_02_IPE_03meses.tif',
        '2024_01_IPE_03meses.tif',
        '2023_12_IPE_03meses.tif',
        '2023_11_IPE_03meses.tif',
        '2023_10_IPE_03meses.tif',
        '2023_09_IPE_03meses.tif',
        '2023_08_IPE_03meses.tif',
        '2023_07_IPE_03meses.tif',
        '2023_06_IPE_03meses.tif',
        '2023_05_IPE_03meses.tif',
        '2023_04_IPE_03meses.tif',
    ],

    [
        '2024_09_IPE_06meses.tif',
        '2024_08_IPE_06meses.tif',
        '2024_07_IPE_06meses.tif',
        '2024_06_IPE_06meses.tif',
        '2024_05_IPE_06meses.tif',
        '2024_04_IPE_06meses.tif',
        '2024_03_IPE_06meses.tif',
        '2024_02_IPE_06meses.tif',
        '2024_01_IPE_06meses.tif',
        '2023_12_IPE_06meses.tif',
        '2023_11_IPE_06meses.tif',
        '2023_10_IPE_06meses.tif',
        '2023_09_IPE_06meses.tif',
        '2023_08_IPE_06meses.tif',
        '2023_07_IPE_06meses.tif',
        '2023_06_IPE_06meses.tif',
        '2023_05_IPE_06meses.tif',
        '2023_04_IPE_06meses.tif',
    ],
    [
        '2024_09_IPE_12meses.tif',
        '2024_08_IPE_12meses.tif',
        '2024_07_IPE_12meses.tif',
        '2024_06_IPE_12meses.tif',
        '2024_05_IPE_12meses.tif',
        '2024_04_IPE_12meses.tif',
        '2024_03_IPE_12meses.tif',
        '2024_02_IPE_12meses.tif',
        '2024_01_IPE_12meses.tif',
        '2023_12_IPE_12meses.tif',
        '2023_11_IPE_12meses.tif',
        '2023_10_IPE_12meses.tif',
        '2023_09_IPE_12meses.tif',
        '2023_08_IPE_12meses.tif',
        '2023_07_IPE_12meses.tif',
        '2023_06_IPE_12meses.tif',
        '2023_05_IPE_12meses.tif',
        '2023_04_IPE_12meses.tif',
    ],
    [
        'FWI_2024_11_12.tif',
        'FWI_2024_11_11.tif',
        'FWI_2024_11_10.tif',
        'FWI_2024_11_09.tif',
        'FWI_2024_11_08.tif',
        'FWI_2024_11_07.tif',
        'FWI_2024_11_06.tif',
        'FWI_2024_11_05.tif',
        'FWI_2024_11_04.tif',
        'FWI_2024_11_03.tif',
        'FWI_2024_11_02.tif',
        'FWI_2024_11_01.tif',
        'FWI_2024_10_31.tif',
        'FWI_2024_10_30.tif',
        'FWI_2024_10_29.tif',
        'FWI_2024_10_28.tif',
        'FWI_2024_10_27.tif',
        'FWI_2024_10_26.tif',
        'FWI_2024_10_25.tif',
        'FWI_2024_10_24.tif',
        'FWI_2024_10_23.tif',
        'FWI_2024_10_22.tif',
        'FWI_2024_10_21.tif',
        'FWI_2024_10_20.tif',
        'FWI_2024_10_19.tif',
        'FWI_2024_10_18.tif',
        'FWI_2024_10_17.tif',
        'FWI_2024_10_16.tif',
        'FWI_2024_10_15.tif',
        'FWI_2024_10_14.tif',
        'FWI_2024_10_13.tif',
        'FWI_2024_10_12.tif',
        'FWI_2024_10_11.tif',
        'FWI_2024_10_10.tif',
    ],
    [
        '20251217_TempAireMinDiaria_Diaria.tif',
        '20251216_TempAireMinDiaria_Diaria.tif',
        '20251215_TempAireMinDiaria_Diaria.tif',
        '20251214_TempAireMinDiaria_Diaria.tif',
        '20251213_TempAireMinDiaria_Diaria.tif',
        '20251212_TempAireMinDiaria_Diaria.tif',
        '20251211_TempAireMinDiaria_Diaria.tif',
    ],
    [
        '20251217_TempAireMaxDiaria_Diaria.tif',
        '20251216_TempAireMaxDiaria_Diaria.tif',
        '20251215_TempAireMaxDiaria_Diaria.tif',
        '20251214_TempAireMaxDiaria_Diaria.tif',
        '20251213_TempAireMaxDiaria_Diaria.tif',
        '20251212_TempAireMaxDiaria_Diaria.tif',
        '20251211_TempAireMaxDiaria_Diaria.tif',
    ],
]

const lsdataEscalasFijas = [
    [],
    [],
    [],
    [],
    [],
    [],
    [],
    [],
    [],
    [],
    [],
    [],
    [],
    [],
    [],
    [],
    [
        '20251217_TempAireMinDiaria_Diaria_escalafija.json',
        '20251216_TempAireMinDiaria_Diaria_escalafija.json',
        '20251215_TempAireMinDiaria_Diaria_escalafija.json',
        '20251214_TempAireMinDiaria_Diaria_escalafija.json',
        '20251213_TempAireMinDiaria_Diaria_escalafija.json',
        '20251212_TempAireMinDiaria_Diaria_escalafija.json',
        '20251211_TempAireMinDiaria_Diaria_escalafija.json',
    ],
    [
        '20251217_TempAireMaxDiaria_Diaria_escalafija.json',
        '20251216_TempAireMaxDiaria_Diaria_escalafija.json',
        '20251215_TempAireMaxDiaria_Diaria_escalafija.json',
        '20251214_TempAireMaxDiaria_Diaria_escalafija.json',
        '20251213_TempAireMaxDiaria_Diaria_escalafija.json',
        '20251212_TempAireMaxDiaria_Diaria_escalafija.json',
        '20251211_TempAireMaxDiaria_Diaria_escalafija.json',
    ],
]

export { lsdata, lsdataEscalasFijas }
